import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import { Dropdown } from 'telstra-ui/components/drop-down/Dropdown';
import { Button } from 'telstra-ui/components/button/Button';
import { GenericAlert } from 'telstra-ui/components/generic-alert/GenericAlert';
import Modal from 'telstra-ui/components/modal/Modal';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import SummaryDetails from '../../../ssm-homepage/ssm-components/summary-details/summary-details';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';
import NumberPillDropDown from '../number-pill-drop-down/number-pill-drop-down';
import Benefit from '../../../ffwd-homepage/ffwd-components/benefit/benefit';
import EstimatedTotalBox from '../../../ffwd-homepage/ffwd-components/estimated-total-box/estimated-total-box';
import { formatNumber } from '../../../../app-actions';
import './optimize-plan-table-view.css';

import {
  OLD_PLAN_TYPE,
  NEW_PLAN_TYPE,
  PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS,
  PLAN_TABLE_ACCOUNT_SELECTED_CLASS_IN_USE,
  PLAN_TABLE_ACCOUNT_SELECTED_CLASS_NOT_IN_USE,
  NGM_YES_TEXT,
} from '../../../../app-constants';

class OptimizePlanTableView extends Component {
  constructor(props) {
    super(props);
    this.setServiceDropdownRef = this.setServiceDropdownRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  state = {
    oldPlanNumbersHideShowData: [],
    newPlanNumbersHideShowData: [],
    selectedPlanNumberArr: [],
    selectedPlanType: '',
    currentPlanTableExpandCollapse: false,
    suggestPlanExpandCollapse: false,
    scrollBothSide: false,
    searchSelectedPlanNumber: '',
    optionsForSearchInput: [],
    displayOptions: [],
    dropDownNumber: '',
    resetInProgress: false,
    resetBtnDisable: true,
    optimizeBtnDisable: true,
    legendModalOpen: false,
    resetModalOpen: false,
    serviceTypeModalOpen: false,
    dropDownPosition: 0,
    isVoicePlan: false,
    isDataPlan: false,
    planCheckboxVal: {},
    movePlanName: '',
    moveIndex: -1,
    windowHeight: '',
  }

  componentDidMount() {
    this.setPlanHideShowFlag(this.props.suggestedPlanDetails.length, NEW_PLAN_TYPE, false);
    this.setPlanHideShowFlag(this.props.planDetails.length, OLD_PLAN_TYPE, false);
    if (this.props.numberSearchDropdown) {
      this.createOptionsForSearchInput(this.props.planDetails);
    }
    document.addEventListener('click', this.handleClickOutside);
    this.state.windowHeight = window.innerHeight;
  }

  componentDidUpdate() {
    this.scrollNumberPillfun();
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  onChangePlanCheckBox = (event, index) => {
    const checkedValue = event.target.checked;
    const planName = event.target.id.split('-')[0];
    const suggestedPlanDetails = this.props.suggestedPlanDetails;
    const selectedPlanNumberArr = this.state.selectedPlanNumberArr;
    const numbers = suggestedPlanDetails[index].numbersOnPlan.map(number => number);

    if (checkedValue) {
      numbers.forEach(number => !selectedPlanNumberArr.includes(number) && selectedPlanNumberArr.push(number));
      this.handlePlansShowHide(index, NEW_PLAN_TYPE, checkedValue, true);
    } else {
      const filterPlanArr = selectedPlanNumberArr.filter(plan => !numbers.includes(plan));
      this.setState({ selectedPlanNumberArr: filterPlanArr });
    }
    const planCheckboxVal = { ...this.state.planCheckboxVal, [planName]: checkedValue };
    this.setState({ planCheckboxVal });
  };

  setPlanHideShowFlag = (planListLength, planType, flag) => {
    const setDataObj = [];
    for (let i = 0; i < planListLength; i += 1) {
      setDataObj[i] = flag;
    }
    if (planType === OLD_PLAN_TYPE) {
      this.setState({
        oldPlanNumbersHideShowData: setDataObj,
        currentPlanTableExpandCollapse: flag,
      });
    } else if (planType === NEW_PLAN_TYPE) {
      this.setState({
        newPlanNumbersHideShowData: setDataObj,
        suggestPlanExpandCollapse: flag,
      });
    }

    /** add functionality for both side number pill scrolling  */
    this.setState({ scrollBothSide: flag, dropDownNumber: '' }, () => { this.scrollNumberPillsBothSideFun(); });
  };

  setServiceDropdownRef(node) {
    this.dropdownRef = node;
  }

  setDropDownNumber = (event) => {
    event.stopPropagation();
    const number = event.target.id;
    const windowHeight = this.state.windowHeight;
    const dropDownValue = event.target.getBoundingClientRect();
    let dropDownPosition;

    ((windowHeight - dropDownValue.top) >= (windowHeight / 2)) ? // eslint-disable-line
      (dropDownPosition = dropDownValue.bottom + 10) : (dropDownPosition = `${dropDownValue.top - 210}`);

    if (this.state.dropDownNumber === number) {
      this.setState({ dropDownNumber: '' });
    } else {
      this.setState({ dropDownNumber: number, dropDownPosition }, () => {
        if (!this.state.selectedPlanNumberArr.includes(number)) {
          const selectedPlanNumberArr = this.state.selectedPlanNumberArr;
          selectedPlanNumberArr.push(number);
          this.setState({ selectedPlanNumberArr });
        }
      });
    }
  }

  getPlanType = (planName, dataOnly) => {
    let planType = '';
    if (planName === 'mobileEssential' || planName === 'mobileEnhanced' || planName === 'mobileEpic' || planName === 'mobileExecutive') {
      planType = 'mobile';
    } else if (planName === 'mobileBroadBandEssential' || planName === 'mobileBroadBandEnhanced' || planName === 'mobileBroadBandEpic') {
      planType = 'mobileBroadBand';
    } else if (planName === 'removePlan') {
      if (dataOnly === true) {
        planType = 'mobileBroadBand';
      } else if (dataOnly === false) {
        planType = 'mobile';
      }
    }
    return planType;
  }

  handleClickOutside(event) {
    const number = event.target.id;
    const dropDownNumber = this.state.dropDownNumber;

    if (this.dropdownRef && dropDownNumber !== number) {
      this.setState({ dropDownNumber: '' });
    }
  }

  handlePlansShowHide = (key, type, flag, bothSideScroll) => {
    const oldPlanData = this.state.oldPlanNumbersHideShowData;
    const newPlanData = this.state.newPlanNumbersHideShowData;

    if (type === OLD_PLAN_TYPE) {
      oldPlanData[key] = flag;
    } else if (type === NEW_PLAN_TYPE) {
      newPlanData[key] = flag;
    }
    this.setState({
      oldPlanNumbersHideShowData: oldPlanData,
      newPlanNumbersHideShowData: newPlanData,
      scrollBothSide: bothSideScroll,
      dropDownNumber: '',
    },
    () => { this.checkAllPlanStatus(type); this.scrollNumberPillsBothSideFun(); });
  };

  scrollNumberPillfun = () => {
    const selectedPlanNumberArr = this.state.selectedPlanNumberArr;
    if (this.state.selectedPlanType && selectedPlanNumberArr.length > 0) {
      let plantype;
      if (this.state.selectedPlanType === OLD_PLAN_TYPE) {
        plantype = NEW_PLAN_TYPE;
      } else if (this.state.selectedPlanType === NEW_PLAN_TYPE) {
        plantype = OLD_PLAN_TYPE;
      }
      const element = document.getElementById(`${selectedPlanNumberArr[selectedPlanNumberArr.length - 1].replace(/\s+/g, '')}-${plantype}`);
      const scrollElementDiv = document.querySelector(`.${plantype} .badge-account-section`);
      if (element && scrollElementDiv) {
        //  scrollElementDiv.scrollTop = element.offsetTop;
      }
    }
  };

  /** function for both side scrolling accoding to number pills */
  scrollNumberPillsBothSideFun = () => {
    const selectedPlanNumberArr = this.state.selectedPlanNumberArr;
    if (this.state.scrollBothSide && selectedPlanNumberArr.length > 0) {
      const element = document.getElementById(`${selectedPlanNumberArr[selectedPlanNumberArr.length - 1].replace(/\s+/g, '')}-${OLD_PLAN_TYPE}`);
      const scrollElementDiv = document.querySelector(`.${OLD_PLAN_TYPE} .selected-number.table-row .badge-account-section`);
      if (element && scrollElementDiv) {
        scrollElementDiv.scrollTop = element.offsetTop;
      }

      const newElement = document.getElementById(`${selectedPlanNumberArr[selectedPlanNumberArr.length - 1].replace(/\s+/g, '')}-${NEW_PLAN_TYPE}`);
      const newScrollElementDiv = document.querySelector(`.${NEW_PLAN_TYPE} .selected-number.table-row .badge-account-section`);
      if (newElement && newScrollElementDiv) {
        //  newScrollElementDiv.scrollTop = newElement.offsetTop;
      }
    }
  }

  checkNumberIndex = () => {
    const selectedPlanNumberArr = this.state.selectedPlanNumberArr;
    if (this.state.selectedPlanType && selectedPlanNumberArr.length > 0) {
      let planList;
      let planType;
      let planIndex;
      if (this.state.selectedPlanType === OLD_PLAN_TYPE) {
        planList = this.props.suggestedPlanDetails;
        planType = NEW_PLAN_TYPE;
      } else if (this.state.selectedPlanType === NEW_PLAN_TYPE) {
        planList = this.props.planDetails;
        planType = OLD_PLAN_TYPE;
      }
      planList.map((plan, index) => {
        if (plan.numbersOnPlan.filter(value => value === selectedPlanNumberArr[selectedPlanNumberArr.length - 1])[0]) {
          planIndex = index;
        }
        return true;
      });

      if (planIndex !== undefined && planIndex !== null) {
        this.handlePlansShowHide(planIndex, planType, true, false);
      }
    }
  }

  checkAllPlanStatus = (PlanType) => {
    if (PlanType === OLD_PLAN_TYPE) {
      const oldPlanStatus = this.state.oldPlanNumbersHideShowData;
      const isAllEqual = oldPlanStatus.every(v => v === oldPlanStatus[0]);
      if (isAllEqual) {
        this.setState({ currentPlanTableExpandCollapse: oldPlanStatus[0] });
      }
    } else if (PlanType === NEW_PLAN_TYPE) {
      const newPlanStatus = this.state.newPlanNumbersHideShowData;
      const isAllEqual = newPlanStatus.every(v => v === newPlanStatus[0]);
      if (isAllEqual) {
        this.setState({ suggestPlanExpandCollapse: newPlanStatus[0] });
      }
    }
  }

  handleNumberSelection = (number, flag, tableType, plan, index) => {
    let selectedPlanNumberArr = this.state.selectedPlanNumberArr;
    if (PLAN_TABLE_ACCOUNT_SELECTED_CLASS_IN_USE === flag || PLAN_TABLE_ACCOUNT_SELECTED_CLASS_NOT_IN_USE === flag) {
      selectedPlanNumberArr = selectedPlanNumberArr.filter(value => value !== number);
      if (tableType !== OLD_PLAN_TYPE) {
        this.serviceCheckBoxValidator(plan.planName, false, index);
      }
    } else if (PLAN_TABLE_ACCOUNT_NOT_SELECT_CLASS === flag) {
      selectedPlanNumberArr.push(number);
      if (tableType !== OLD_PLAN_TYPE) {
        this.serviceCheckBoxValidator(plan.planName, true, index);
      }
    }
    this.setState({ selectedPlanNumberArr, selectedPlanType: tableType, dropDownNumber: '' }, () => this.checkNumberIndex());
  };

  handleExpandCollapseAllPlans = (planlength, TableExpandCollapse, tableType) => {
    this.setPlanHideShowFlag(planlength, tableType, !TableExpandCollapse);
  }

  serviceCheckBoxValidator = (plan, flag, index) => {
    const numbers = this.props.suggestedPlanDetails[index].numbersOnPlan.map(n => n);
    const planCheckboxVal = { ...this.state.planCheckboxVal, [plan]: flag };
    const isEqual = numbers.every(i => this.state.selectedPlanNumberArr.indexOf(i) !== -1);
    if (numbers && isEqual) this.setState({ planCheckboxVal });
  };

  createOptionsForSearchInput = (planDetails) => {
    const Options = [];
    planDetails.map((planList) => {
      planList.numbersOnPlan.map((number) => {
        const Data = { displayText: number.replace(/ /g, ''), itemId: number.replace(/ /g, '') };
        return Options.push(Data);
      });
      return false;
    });
    this.setState({ optionsForSearchInput: Options, displayOptions: Options, searchSelectedPlanNumber: '' });
  }

  searchNumber = (event) => {
    const searchText = event.target.value;
    const options = this.state.optionsForSearchInput.filter((option) => {
      const optionText = option.displayText;
      const textWithoutSpaces = optionText.replace(/ /g, '');
      const match = textWithoutSpaces.match(searchText);
      if (match != null && match.index !== undefined) {
        return true;
      }
      return false;
    });
    this.setState({ displayOptions: options });
  }

  selectSearchOption = (event) => {
    const selectedNumber = event.target.getAttribute('data-item');
    const selectedPlanNumberArr = this.state.selectedPlanNumberArr;
    selectedPlanNumberArr.push(selectedNumber);
    this.setState({
      searchSelectedPlanNumber: selectedNumber,
      selectedPlanNumberArr,
      selectedPlanType: NEW_PLAN_TYPE,
      scrollBothSide: true,
    }, () => {
      this.checkNumberIndex();
      this.setState({ selectedPlanType: OLD_PLAN_TYPE }, () => { this.checkNumberIndex(); this.scrollNumberPillsBothSideFun(); });
      this.props.setSearchUsedValue({ searchUsed: NGM_YES_TEXT });
    });
  }

  movePlan = (moveIndex, planName) => {
    let optimizeBtnDisableCurrent = this.state.optimizeBtnDisable;
    if (planName === 'removePlan' || optimizeBtnDisableCurrent === false) {
      optimizeBtnDisableCurrent = false;
    }
    const selectedPlanNumberArr = this.state.selectedPlanNumberArr;
    let planType = '';
    if (planName === 'mobileEssential' || planName === 'mobileEnhanced' || planName === 'mobileEpic' || planName === 'mobileExecutive') {
      planType = 'mobile';
    } else if (planName === 'mobileBroadBandEssential' || planName === 'mobileBroadBandEnhanced' || planName === 'mobileBroadBandEpic') {
      planType = 'mobileBroadBand';
    }
    const { serviceNumbersWithFlag } = this.props;

    const isPlanTypeDifferent = selectedPlanNumberArr
      .some(number => this.getPlanType(serviceNumbersWithFlag[number].planName, serviceNumbersWithFlag[number].dataOnly) !== planType);

    const planCheckboxState = { ...this.state.planCheckboxVal };
    const planCheckboxVal = this.filterPlanCheckboxVal(planCheckboxState);

    if (isPlanTypeDifferent && planName !== 'removePlan') {
      this.setState({ moveIndex, movePlanName: planName, planCheckboxVal });
      this.serviceTypeModalOpen();
    } else {
      this.props.movePlan(moveIndex, planName, selectedPlanNumberArr);
      this.setState({
        dropDownNumber: '',
        selectedPlanNumberArr: [],
        resetBtnDisable: false,
        optimizeBtnDisable: optimizeBtnDisableCurrent,
        planCheckboxVal,
      });
    }
  };

  filterPlanCheckboxVal = (plan) => {
    Object.keys(plan).forEach(key => plan[key] = false); // eslint-disable-line
    return plan;
  }

  movePlanAgreed = () => {
    const { moveIndex, movePlanName, selectedPlanNumberArr } = this.state;
    this.props.movePlan(moveIndex, movePlanName, selectedPlanNumberArr);
    this.setState({
      dropDownNumber: '',
      selectedPlanNumberArr: [],
      resetBtnDisable: false,
      serviceTypeModalOpen: false,
    });
  }

  resetPlan = () => {
    this.setState({ resetModalOpen: true });
  }

  resetPlanComplete = () => {
    this.props.resetAllPlan();
    this.setState({ resetModalOpen: false, resetBtnDisable: true });
  }


  legendModalClose = () => {
    this.setState({ legendModalOpen: false });
  }

  legendModalOpen = () => {
    this.setState({ legendModalOpen: true });
  }

  resetModalClose = () => {
    this.setState({ resetModalOpen: false });
  }

  serviceTypeModalOpen = () => {
    this.setState({ serviceTypeModalOpen: true });
  }

  serviceTypeModalClose = () => {
    this.setState({ serviceTypeModalOpen: false });
  }

  resetModalOpen = () => {
    this.setState({ resetModalOpen: true });
  }

  render() {
    const {
      recommededPlans: {
        recommededPlanHeading,
        estimatedPriceText,
        strategicSolutions,
        currentFleet,
        siosText,
        totalText,
        expandAllText,
        collapseAllText,
        gbText,
        moveToText,
        resetText,
        optimizeText,
        tooltipAdaptiveHeading,
        tooltipDescription,
        tooltipVoiceText,
        tooltipDataText,
        tooltipServicesHeading,
        tooltipServices,
        tooltipServiceUse,
        tooltipServiceNoUse,
        tooltipSelected,
        tooltipUnSelected,
        cancelText,
        resetDescription,
        serviceTypeModalText,
        okText,
        avgDataPreText,
        avgDataPostText,
        showMoreText,
        showLessText,
        showMoreCountValue,
      },
      planDetails,
      recommededPlanDescription,
      estimatedTotalCurrentMonthlyCost,
      benefitValues,
      searchDropdownText,
      customHeadingClass,
      optimizeInProgress,
      suggestedPlanDetails,
      estimatedTotalNewMonthlyCost,
      serviceNumbersWithFlag,
      avgDataUsage,
      cohortAndAcncText,
    } = this.props;

    const oldPlanTableKeys = {
      tableHeading: currentFleet,
      siosText,
      planDetails,
      totalText,
      expandAllText,
      collapseAllText,
      showMoreText,
      showLessText,
      showMoreCountValue,
    };

    const newPlanTableKeys = {
      tableHeading: strategicSolutions,
      siosText,
      planDetails: suggestedPlanDetails,
      totalText,
      expandAllText,
      collapseAllText,
      moveToText,
      showMoreText,
      showLessText,
      showMoreCountValue,
    };

    let moreDataBenefit = {};
    let amountPerMonthBenefit = {};
    let additionalDataBenefit = {};
    if (benefitValues !== null && benefitValues !== undefined) {
      moreDataBenefit = { ...this.props.moreDataBenefit, benefitValues: benefitValues.moreDataBenefit };
      amountPerMonthBenefit = {
        ...this.props.amountPerMonthBenefit,
        benefitValues: `<sup>$</sup>${benefitValues.amountPerMonthBenefit}`,
      };
      additionalDataBenefit = {
        ...this.props.additionalDataBenefit,
        benefitValues: `${benefitValues.additionalDataBenefit}<sup>${gbText}</sup>`,
      };
    }

    return (
      <div className="recommended-plans-section padding-top-bottom-24">
        <SummaryDetails
          summaryTitle={recommededPlanHeading}
          summaryText={stripStartingAndEndingPTags(recommededPlanDescription)}
          customHeadingClass={customHeadingClass}
        />
        {cohortAndAcncText.length > 5 &&
          <div className="row cohort-banner">
              <div className="col-12">
                <GenericAlert
                  name="cohort-banner-primary"
                  description={renderHTML(cohortAndAcncText)}
                />
              </div>
          </div>
        } 
        <div className="row">
          <div className="col-12">
            {renderHTML(avgDataPreText)} <b>{formatNumber(avgDataUsage, 0)} {gbText}</b> {renderHTML(avgDataPostText)}
          </div>
        </div>
        {benefitValues &&
          <div className="benefit-widget-section padding-top-bottom-24 row text-center" id="benefit-widget-section">
            <Benefit
              benefit={moreDataBenefit}
            />
            <Benefit
              benefit={amountPerMonthBenefit}
            />
            <Benefit
              benefit={additionalDataBenefit}
            />
          </div>
        }
        <div className="estimated-box-section padding-top-bottom-24">
          <div className="row">
            <div className="col-md-6 old-plan-cost">
              <EstimatedTotalBox
                estimatedSection={estimatedTotalCurrentMonthlyCost}
              />
            </div>
            <div className="col-md-6 new-plan-cost">
              <EstimatedTotalBox
                estimatedSection={estimatedTotalNewMonthlyCost}
              />
            </div>
            <div className="col-md-12 pl-sm-0 estimatedPriceText">
              {renderHTML(estimatedPriceText)}
            </div>
          </div>
        </div>
        {this.props.numberSearchDropdown &&
          <div className="row number-search-section">
            <div className="col-lg-4 col-sm-12">
              <Dropdown
                dropdownId="number-search-dropdown"
                label={searchDropdownText}
                value={this.state.searchSelectedPlanNumber}
                searchOnChange={this.searchNumber}
                searchBox
                highlightSelected
                options={this.state.displayOptions}
                onOptionClick={this.selectSearchOption}
              />
            </div>
            <div className="col-lg-8 col-sm-12 text-right">
              <Button
                variant="primary"
                onClick={() => this.props.submitAMSOptimizePlanData(suggestedPlanDetails)}
                icon={`${optimizeInProgress ? 'icon-system-loading' : ''}`}
                size="medium"
                iconPosition="right"
                className="test-class d-none"
                disabled={this.state.optimizeBtnDisable && this.props.optimizeBtnDisabled}
              >
                {optimizeText}
              </Button>
              <Button
                variant="primary"
                onClick={this.resetPlan}
                icon={`${this.state.resetInProgress ? 'icon-system-loading' : ''}`}
                size="medium"
                iconPosition="right"
                className="test-class"
                disabled={this.state.resetBtnDisable && this.props.resetBtnDisabled}
              >
                {resetText}
              </Button>
              <button onClick={this.legendModalOpen} className="legend-open-icon-btn">
                <SvgIcon name="icon-system-info" className="legend-open-icon" />
              </button>
            </div>
          </div>
        }
        <div className="row plan-table-section-staff padding-top-bottom-24 row" id="plan-table-section">
          <div className={`col-6 ${OLD_PLAN_TYPE}-Staff`}>
            <NumberPillDropDown
              planTableData={oldPlanTableKeys}
              showHideNumbersSection={this.state.oldPlanNumbersHideShowData}
              handlePlansShowHide={this.handlePlansShowHide}
              tableType={OLD_PLAN_TYPE}
              expandedFeature
              handleNumberSelection={this.handleNumberSelection}
              selectedPlanNumberArr={this.state.selectedPlanNumberArr}
              handleExpandCollapseAllPlans={this.handleExpandCollapseAllPlans}
              tableExpandCollapse={this.state.currentPlanTableExpandCollapse}
              customNumberBadgeClass="badge-account-number-left"
              serviceNumbersWithFlag={serviceNumbersWithFlag}
            />
          </div>
          <div className={`col-6 ${NEW_PLAN_TYPE}-Staff`}>
            <NumberPillDropDown
              planTableData={newPlanTableKeys}
              showHideNumbersSection={this.state.newPlanNumbersHideShowData}
              handlePlansShowHide={this.handlePlansShowHide}
              tableType={NEW_PLAN_TYPE}
              expandedFeature
              handleNumberSelection={this.handleNumberSelection}
              selectedPlanNumberArr={this.state.selectedPlanNumberArr}
              handleExpandCollapseAllPlans={this.handleExpandCollapseAllPlans}
              tableExpandCollapse={this.state.suggestPlanExpandCollapse}
              dropDown
              dropDownNumber={this.state.dropDownNumber}
              setDropDownNumber={this.setDropDownNumber}
              movePlan={this.movePlan}
              serviceNumbersWithFlag={serviceNumbersWithFlag}
              optimizeInProgress={optimizeInProgress}
              customNumberBadgeClass="badge-account-number-right"
              dropDownPosition={this.state.dropDownPosition}
              planCheckboxVal={this.state.planCheckboxVal}
              onChangePlanCheckBox={this.onChangePlanCheckBox}
              setServiceDropdownRef={this.setServiceDropdownRef}
            />
          </div>
        </div>

        <Modal
          isOpen={this.state.legendModalOpen}
          onShowModal={this.legendModalClose}
          size="large"
          className="legend-modal"
        >
          <Modal.Header>
            <div className="row">
              <div className="col-6">
                {tooltipAdaptiveHeading}
              </div>
              <div className="col-6">
                {tooltipServicesHeading}
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-6">
                <div className="row">
                  <div className="col-12 adaptive-service">
                    {tooltipDescription}
                  </div>
                  <div className="col-12 mobile-service">
                    <SvgIcon name="icon-mobiles-mobile" className="tooltip-left-icons" />
                    {tooltipVoiceText}
                  </div>
                  <div className="col-12 broadband-service">
                    <SvgIcon name="icon-authentication-hotspot" className="tooltip-left-icons" />
                    {tooltipDataText}
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-12 tooltip-service">
                    {tooltipServices}
                  </div>
                  <div className="col-12 service-use">
                    {tooltipServiceUse}
                  </div>
                  <div className="col-6 unselected-text">
                    {tooltipUnSelected}
                  </div>
                  <div className="col-6 selected-text">
                    {tooltipSelected}
                  </div>
                  <div className="col-6">
                    <span className="tooltip-number-in-use-unselected number-pill">
                      <SvgIcon name="icon-mobiles-mobile" className="svg-unselected-in-use" />
                      0422 222 222
                    </span>
                  </div>
                  <div className="col-6">
                    <span className="tooltip-number-in-use-selected number-pill">
                      <SvgIcon name="icon-mobiles-mobile" className="svg-selected-in-use" />
                      0422 222 222
                    </span>
                  </div>

                  <div className="col-12 service-not-use">
                    {tooltipServiceNoUse}
                  </div>
                  <div className="col-6 unselected-text">
                    {tooltipUnSelected}
                  </div>
                  <div className="col-6 selected-text">
                    {tooltipSelected}
                  </div>
                  <div className="col-6">
                    <span className="tooltip-number-not-in-use-unselected number-pill">
                      <SvgIcon name="icon-mobiles-mobile" className="svg-unselected-not-in-use" />
                      0422 222 222
                    </span>
                  </div>
                  <div className="col-6">
                    <span className="tooltip-number-not-in-use-selected number-pill">
                      <SvgIcon name="icon-mobiles-mobile" className="svg-selected-not-in-use" />
                      0422 222 222
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>


        <Modal
          isOpen={this.state.resetModalOpen}
          onShowModal={this.resetModalClose}
          modalType="alert-modal-warning"
          size="large"
          className="reset-modal"
        >
          <Modal.Header>
            <div className="row">
              <div className="col-12">
                <SvgIcon name="icon-system-alert-small" className="svg-unselected-not-in-use" /> {resetText}
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12">
                {resetDescription}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              size="xSmall"
              onClick={this.resetModalClose}
            >{cancelText}
            </Button>
            <Button
              variant="super"
              size="medium"
              state="app"
              onClick={this.resetPlanComplete}
            >{resetText}
            </Button>

          </Modal.Footer>
        </Modal>

        <Modal
          isOpen={this.state.serviceTypeModalOpen}
          onShowModal={this.serviceTypeModalClose}
          size="large"
          modalType="alert-modal-warning"
          className="service-type-modal"
        >
          <Modal.Header>
            <div className="row">
              <div className="col-12">
                {serviceTypeModalText}
              </div>
            </div>
          </Modal.Header>
          <Modal.Body>
            <span>&nbsp;</span>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              size="xSmall"
              onClick={this.serviceTypeModalClose}
            >{cancelText}
            </Button>
            <Button
              variant="super"
              size="medium"
              state="app"
              onClick={() => this.movePlanAgreed()}
            >{okText}</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default OptimizePlanTableView;
